import { render, staticRenderFns } from "./CourseMediaViewModal.vue?vue&type=template&id=148b9458&scoped=true"
import script from "./CourseMediaViewModal.vue?vue&type=script&lang=js"
export * from "./CourseMediaViewModal.vue?vue&type=script&lang=js"
import style0 from "./CourseMediaViewModal.vue?vue&type=style&index=0&id=148b9458&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b9458",
  null
  
)

export default component.exports